<editor [id]="id" formControlName="notes" [init]="{ base_url: '/tinymce',  suffix: '.min', plugins: 'lists link table code help wordcount'}" ></editor>
